import useGetTagsListQuery from '../queries/useGetTagsListQuery';

const useFetchTagsList = () => {
  const { data, isLoading, error, refetch } = useGetTagsListQuery();

  return { data: data || [], isLoading, error, refetch };
};

export default useFetchTagsList;
